/**
 * Account-settings sub-nav — horizontal strip rendered directly below
 * the main UserNav on account-settings pages (Kontaktuppgifter,
 * Lösenord, etc.). Was previously a left-aside TabNav; flipped to
 * horizontal to match the rest of Wheelplace's nav vocabulary and to
 * avoid a two-column layout on a single-form page.
 */
import React from 'react';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';

import { FormattedMessage } from '../../../util/reactIntl';

import { LinkTabNavHorizontal } from '../../../components';

import css from './LayoutSideNavigation.module.css';

const LayoutWrapperAccountSettingsSideNav = props => {
  const { currentPage } = props;
  const { currentUser } = useSelector(state => state.user);
  const userType = currentUser?.attributes?.profile?.publicData?.userType;

  let tabs = [
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.contactDetailsTabTitle" />,
      selected: currentPage === 'ContactDetailsPage',
      id: 'ContactDetailsPageTab',
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.passwordTabTitle" />,
      selected: currentPage === 'PasswordChangePage',
      id: 'PasswordChangePageTab',
      linkProps: {
        name: 'PasswordChangePage',
      },
    },
    // These tabs are commented out because you should not be able to
    // connect Stripe to your account in Wheelplace.
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentsTabTitle" />,
      selected: currentPage === 'StripePayoutPage',
      id: 'StripePayoutPageTab',
      linkProps: {
        name: 'StripePayoutPage',
      },
    },
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentMethodsTabTitle" />,
      selected: currentPage === 'PaymentMethodsPage',
      id: 'PaymentMethodsPageTab',
      linkProps: {
        name: 'PaymentMethodsPage',
      },
    },
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.subUsersTabTitle" />,
      selected: currentPage === 'SubUsersPage',
      id: 'SubUsersPageTab',
      linkProps: {
        name: 'SubUsersPage',
      },
    },
    {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AccessRequestTabTitle" />,
      selected: currentPage === 'AccessRequestPage',
      id: 'AccessRequestPageTab',
      linkProps: {
        name: 'AccessRequestPage',
      },
    },
  ];

  if (userType === 'private') {
    tabs = tabs.filter(tab => {
      return (
        tab.id !== 'StripePayoutPageTab' &&
        tab.id !== 'PaymentMethodsPageTab' &&
        tab.id !== 'SubUsersPageTab' &&
        tab.id !== 'AccessRequestPageTab'
      );
    });
  }

  /* Outer bar paints the full-width strip; inner caps content at
   * contentMaxWidth. Mirrors UserNav so the two nav rows stack
   * identically. */
  return (
    <div className={css.subNavBar}>
      <LinkTabNavHorizontal
        className={css.subNavInner}
        tabRootClassName={css.subNavTab}
        tabs={tabs}
      />
    </div>
  );
};

LayoutWrapperAccountSettingsSideNav.defaultProps = {
  currentPage: null,
};

LayoutWrapperAccountSettingsSideNav.propTypes = {
  currentPage: string,
};

export default LayoutWrapperAccountSettingsSideNav;
